import React, { useEffect, useState } from "react";
import "./Home.css";
import Product from "../Product/Product";
import Navbar from "../../Components/Navbar/Navbar";
import SEO from "../../Components/SEO/SEO";
import Footer from "../../Components/Footer/Footer";
import { ArrowRight, ShoppingBag, Truck, ShieldCheck } from "lucide-react";
import HeaderImage from "../../Components/Assets/images/header_main.png";
import HeaderImage2 from "../../Components/Assets/images/header_main2.png";
import HeaderImage3 from "../../Components/Assets/images/header_main3.png";
import HeaderImage4 from "../../Components/Assets/images/header_main4.png";
import HeroBg1 from "../../Components/Assets/images/1.png";
import HeroBg2 from "../../Components/Assets/images/2.png";
import HeroBg3 from "../../Components/Assets/images/3.png";
import HeroBg4 from "../../Components/Assets/images/4.png";
import HomeImage1 from "../../Components/Assets/images/header_home1.png";
import HomeImage from "../../Components/Assets/images/mobile_home1.png";
import BannerImage1 from "../../Components/Assets/images/banner_2.png";
import BannerImage2 from "../../Components/Assets/images/banner_3.png";
import { tablesDB, DB_ID, PRODUCTS_TABLE } from "../../appwrite";
import { Query } from "appwrite";

const shuffleArray = (arr) => {
  const s = arr.slice();
  for (let i = s.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [s[i], s[j]] = [s[j], s[i]];
  }
  return s;
};

const CATEGORIES = [
  { slug: "reup-vault", label: "ReUp Vault", emoji: "👟" },
  { slug: "value-packs", label: "Value Packs", emoji: "🛒" },
  { slug: "fresh-farm-produce", label: "Fresh Farm", emoji: "🥦" },
  { slug: "grains-and-staples", label: "Grains & Staples", emoji: "🌾" },
  { slug: "meat-and-livestock", label: "Meat & Livestock", emoji: "🥩" },
  { slug: "dairy-and-eggs", label: "Dairy & Eggs", emoji: "🥚" },
  { slug: "beverages", label: "Beverages", emoji: "🥤" },
  { slug: "snacks-and-confectionery", label: "Snacks", emoji: "🍫" },
  { slug: "frozen-foods", label: "Frozen Foods", emoji: "❄️" },
  { slug: "canned-and-packaged-foods", label: "Canned Foods", emoji: "🥫" },
  { slug: "condiments-and-sauces", label: "Condiments", emoji: "🧴" },
];

const HEADER_IMAGES = [
  { src: HeaderImage, link: "/shop/all" },
  { src: HeaderImage2, link: "/shop/reup-vault" },
  { src: HeaderImage3, link: "/shop/reup-vault" },
  { src: HeaderImage4, link: "/shop/reup-vault" },
];

const HERO_BG_IMAGES = [HeroBg1, HeroBg2, HeroBg3, HeroBg4];

export default function Home() {
  const [products, setProducts] = useState([]);
  const [shuffled, setShuffled] = useState([]);
  const [headerIndex, setHeaderIndex] = useState(0);
  const [heroBgIndex, setHeroBgIndex] = useState(0);

  useEffect(() => {
    tablesDB
      .listRows({
        databaseId: DB_ID,
        tableId: PRODUCTS_TABLE,
        queries: [
          Query.equal("featured", true),
          Query.orderDesc("$createdAt"),
          Query.limit(120),
        ],
      })
      .then((res) => {
        const data = (res.rows || []).map((r) => ({ id: r.$id, ...r }));
        setProducts(data);
      })
      .catch(console.error);
  }, []);

  useEffect(() => {
    setShuffled(shuffleArray(products));
  }, [products]);

  useEffect(() => {
    const t = setInterval(() => {
      setHeaderIndex((prev) => {
        let next;
        do {
          next = Math.floor(Math.random() * HEADER_IMAGES.length);
        } while (next === prev && HEADER_IMAGES.length > 1);
        return next;
      });
    }, 5000);
    return () => clearInterval(t);
  }, []);

  useEffect(() => {
    const t = setInterval(() => {
      setHeroBgIndex((prev) => (prev + 1) % HERO_BG_IMAGES.length);
    }, 4000);
    return () => clearInterval(t);
  }, []);

  const renderSection = (catSlug, label) => {
    const filtered = shuffled.filter((p) => p.category === catSlug).slice(0, 6);
    if (filtered.length === 0) return null;
    return (
      <section className="home-section" id={catSlug} key={catSlug}>
        <div className="home-section__header">
          <a href={`/shop/${catSlug}`}>
            <h2 className="home-section__title">{label}</h2>
          </a>
        </div>
        <div className="home-grid">
          {filtered.map((p) => (
            <Product
              key={p.id}
              product_id={p.id}
              productImage={p.productImage}
              productName={p.productName}
              price={p.price}
              productDescription={p.productDescription}
              category={p.category}
              showCategory={false}
            />
          ))}
        </div>
      </section>
    );
  };

  const orgSchema = {
    "@context": "https://schema.org",
    "@type": "WebSite",
    "name": "TrendBay Mart",
    "url": "https://mart.trendbayds.com",
    "potentialAction": {
      "@type": "SearchAction",
      "target": "https://mart.trendbayds.com/shop/all?q={search_term_string}",
      "query-input": "required name=search_term_string",
    },
  };

  return (
    <div className="home">
      <SEO
        title="Nigeria's Daily Marketplace — Fresh Produce, Essentials & More"
        description="Shop fresh farm produce, grains, dairy, beverages, snacks, and authentic pre-owned items on TrendBay Mart. Fast delivery across Nigeria."
        path="/"
        jsonLd={orgSchema}
      />
      <Navbar />

      {/* ── Hero ── */}
      <section className="hero d-none d-md-block">
        {HERO_BG_IMAGES.map((src, i) => (
          <img
            key={i}
            src={src}
            className={`hero__bg-slide${heroBgIndex === i ? " hero__bg-slide--active" : ""}`}
            alt=""
          />
        ))}
        <div className="hero__dot-grid" />
        <div className="hero__content">
          <p className="hero__eyebrow mb-5 pb-5"></p>
          <p className="hero__eyebrow mb-2 pb-2"></p>
          <div className="hero__text-gap" />
          <div className="hero__ctas">
            <a href="/shop/all" className="hero__btn hero__btn--primary">
              <ShoppingBag size={17} /> Shop Now
            </a>
            <a href="/shop/reup-vault" className="hero__btn hero__btn--ghost">
              ReUp Vault <ArrowRight size={15} />
            </a>
          </div>
        </div>
        <div className="hero__trust">
          <div className="hero__trust-item">
            <Truck size={16} /> Fast Delivery
          </div>
          <div className="hero__trust-item">
            <ShieldCheck size={16} /> Verified Sellers
          </div>
          <div className="hero__trust-item">
            <ShoppingBag size={16} /> 500+ Products
          </div>
        </div>
      </section>

      {/* ── Category pills ── */}
      <section className="cat-pills">
        <div className="cat-pills__track">
          {CATEGORIES.map((c) => (
            <a
              key={c.slug}
              href={`#${c.slug}`}
              className="cat-pill"
              onClick={(e) => {
                const el = document.getElementById(c.slug);
                if (el) {
                  e.preventDefault();
                  el.scrollIntoView({ behavior: "smooth", block: "start" });
                }
              }}
            >
              <span className="cat-pill__emoji">{c.emoji}</span>
              <span>{c.label}</span>
            </a>
          ))}
        </div>
      </section>

      {/* ── Header image banner (desktop) ── */}
      <div className="home-container">
        {renderSection("reup-vault", "ReUp Vault")}
        {renderSection("value-packs", "Value Packs")}
        {renderSection("fresh-farm-produce", "Fresh Farm Produce")}

        {/* Mid-page banner */}
        <div className="home-banner d-none d-md-block mt-4">
          <a href="/shop/fresh-farm-produce">
            <img src={HomeImage1} className="home-banner__img" alt="TrendBay" />
          </a>
        </div>
        <div className="home-banner d-block d-md-none d-lg-none mt-4">
          <a href="/shop/fresh-farm-produce">
            <img src={HomeImage} className="home-banner__img" alt="TrendBay" />
          </a>
        </div>

        {renderSection("meat-and-livestock", "Meat & Livestock")}
        {renderSection("grains-and-staples", "Grains & Staples")}
        {renderSection("frozen-foods", "Frozen Foods")}
        {renderSection("canned-and-packaged-foods", "Canned & Packaged Foods")}
        {renderSection("dairy-and-eggs", "Dairy & Eggs")}

        <div className="home-banner d-none d-md-block mt-4">
          <a href="/shop/all">
            <img
              src={BannerImage1}
              className="home-banner__img"
              alt="TrendBay"
            />
          </a>
        </div>
        <div className="home-banner d-block d-md-none d-lg-none mt-4">
          <a href="/shop/all">
            <img
              src={BannerImage2}
              className="home-banner__img"
              alt="TrendBay"
            />
          </a>
        </div>

        {renderSection("beverages", "Beverages")}
        {renderSection("snacks-and-confectionery", "Snacks & Confectionery")}
        {renderSection("condiments-and-sauces", "Condiments & Sauces")}
      </div>

      <Footer />
    </div>
  );
}
